/**
 *
 */
const setCurrentSelectedLanguage = ($) => () => {
    const currentLang = $('.lang-nav__item--active a').first().text();
    const mapping = {
        DE: 'Deutsch',
        EN: 'English',
        FR: 'Français',
        ES: 'Español',
    };
    const target = $(`input[value="${mapping[currentLang]}"]`);
    target.prop('checked', true);
    target.trigger('change');
    $('.select').trigger('change');
};
export default setCurrentSelectedLanguage;



// WEBPACK FOOTER //
// ./src/scripts/components/downloads-list/setCurrentSelectedLanguage.js